import React, { useRef, useState } from 'react';
import Card from '../../../../components/common/Card/Card';
import ExerciseThumbnailImage from '../../../../components/common/ExerciseThumbnailImage/ExerciseThumbnailImage';
import type { ExerciseItem } from '../../../../types/exercise';
import { beginTrainingDragAutoScroll, endTrainingDragAutoScroll } from '../../utils/trainingDragAutoScroll';
import { clearActiveTrainingDrag } from '../../utils/trainingDragData';
import styles from './TrainingCatalogCard.module.css';

interface TrainingCatalogCardProps {
  exercise: ExerciseItem;
  isSelected: boolean;
  onSelect: (exercise: ExerciseItem) => void;
  onDragStart: (event: React.DragEvent<HTMLButtonElement>, exercise: ExerciseItem) => void;
  showSelectedCheck?: boolean;
}

const TrainingCatalogCard: React.FC<TrainingCatalogCardProps> = ({
  exercise,
  isSelected,
  onSelect,
  onDragStart,
  showSelectedCheck = false,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const skipClickAfterDragRef = useRef(false);

  const handleClick = () => {
    if (skipClickAfterDragRef.current) {
      skipClickAfterDragRef.current = false;
      return;
    }

    onSelect(exercise);
    window.open(`/exercicios/${exercise.id}/editar`, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      className={`${styles.button}${isDragging ? ` ${styles.buttonDragging}` : ''}`}
      onClick={handleClick}
      onDragStart={(event) => {
        skipClickAfterDragRef.current = true;
        beginTrainingDragAutoScroll();
        setIsDragging(true);
        onDragStart(event, exercise);
      }}
      onDragEnd={() => {
        endTrainingDragAutoScroll();
        clearActiveTrainingDrag();
        setIsDragging(false);
        window.setTimeout(() => {
          skipClickAfterDragRef.current = false;
        }, 0);
      }}
      aria-pressed={isSelected}
      aria-label={`${exercise.name}. Clique para editar, arraste para o treino`}
      draggable
    >
      <Card className={`${styles.card}${isSelected ? ` ${styles.selected}` : ''}${showSelectedCheck && isSelected ? ` ${styles.selectedWithCheck}` : ''}${isDragging ? ` ${styles.dragging}` : ''}`}>
        {showSelectedCheck && isSelected && (
          <span className={styles.selectedCheck} aria-hidden="true">
            <span className="material-symbols-outlined">check</span>
          </span>
        )}
        <div className={styles.content}>
          <ExerciseThumbnailImage
            exerciseId={exercise.id}
            exerciseName={exercise.name}
            alt={`Thumbnail do exercicio ${exercise.name}`}
            className={styles.thumbnail}
          />

          <div className={styles.textContent}>
            <span className={styles.name} title={exercise.name}>{exercise.name}</span>
          </div>
        </div>
      </Card>
    </button>
  );
};

export default TrainingCatalogCard;